import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  settings: null,
};

export const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
  },
});

export const { setLoading, setSettings } = settingSlice.actions;

export default settingSlice.reducer;
